import React from 'react';
import { IconContainer } from './IconContainer';

const AttachmentIcon = (props) => {
    return (
        <IconContainer aria-label="icon: attachment" { ...props }>
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M42 16V41.986C42.0018 42.2486 41.9519 42.5091 41.8531 42.7524C41.7543 42.9958 41.6085 43.2173 41.4241 43.4043C41.2397 43.5913 41.0203 43.7402 40.7783 43.8424C40.5364 43.9446 40.2766 43.9982 40.014 44H7.986C7.45963 44 6.95478 43.791 6.58239 43.419C6.21 43.047 6.00053 42.5424 6 42.016V5.984C6 4.91 6.898 4 8.004 4H29.994L42 16ZM38 18H28V8H10V40H38V18ZM16 14H22V18H16V14ZM16 22H32V26H16V22ZM16 30H32V34H16V30Z" fill="#CDD8ED"/>
            </svg>
        </IconContainer>
    )
}

export { AttachmentIcon };